import Vuex from 'vuex';
import Vue from 'vue';
import { FAQ_NAMESPACE, faq } from './modules/faq/faq.store.js';
import { CONSENTS_NAMESPACE, consent } from './modules/consents/consents.store.js';
import { OFFER_NAMESPACE, offers } from './modules/offer/offer.store.js';
import { STATIC_PAGES_NAMESPACE, staticPage } from './modules/static-pages/static-pages.store.js';
import { PROMOTIONS_NAMESPACE, promotions } from './modules/promotions/promotions.store.js';

var _a;
Vue.use(Vuex);
var store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: (_a = {},
        _a[FAQ_NAMESPACE] = faq,
        _a[CONSENTS_NAMESPACE] = consent,
        _a[OFFER_NAMESPACE] = offers,
        _a[STATIC_PAGES_NAMESPACE] = staticPage,
        _a[PROMOTIONS_NAMESPACE] = promotions,
        _a),
});

export { store };
